import {
  AppSessionsQueryResult,
  OrganizationAppSessionsQueryResult
} from "@/api";
import { useEffect, useState } from "react";
import { AppSessionsView } from "./AppSessionsView";

interface Props {
  query: AppSessionsQueryResult | OrganizationAppSessionsQueryResult;
}

export function AnalyticsView({ query }: Props) {
  const { data, error, fetchMore } = query();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!data) return;

    setLoading(true);
    if (data.pageInfo.hasNextPage)
      fetchMore({
        variables: { after: data.pageInfo.endCursor }
      }).catch((err) => console.error("Error fetching app sessions. ", err));
    else setLoading(false);
  }, [data, fetchMore]);

  if (error) console.error("Error fetching app sessions", error);

  return (
    <div className="flex flex-col max-h-screen">
      <AppSessionsView appSessions={data?.edges || []} loading={loading} />
    </div>
  );
}
